export const API_GET_ALL_COMPANY_PARTNER = "/partner/";
export const API_GET_SEARCH_COMPANY = '/admin/empresas/buscar/';
export const API_POST_SAVE_PARTNERS = "/partner/registrar";
export const API_GET_ALL_COMPANY = "/admin/empresas/";
export const API_GET_AVAILABLE_VOUCHERS = "/partner/obtenerComprobantesDisponibles/"
export const API_POST_SAVE_PROVAIDER = "/admin/proveedores/registro-proveedor";
export const API_PUT_UPDATE_COSTUMERS = "/admin/clientes/actualizar-cliente/";
export const API_GET_ALL_LOCATIONS = "/admin/ubicacionGeografica/unificada";
export const API_POST_SAVE_ADD_VOUCHER = "partner/registrar/paquete/empresa";
export const API_POST_REGISTER_VOUCHER = "partner/registrar/paquete";